import React, { useEffect } from 'react';

const AppRedirect: React.FC = () => {
    useEffect(() => {
        // Liens vers les apps
        const appLinks = {
            googlePlay: "https://play.google.com/store/apps/details?id=com.yatamedical.YataPatient",
            appStore: "https://apps.apple.com/us/app/yata-m%C3%A9dical/id6615080510",
            default: "https://about.yatamedical.com/"
        };

        // Détecter l'OS et rediriger
        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

        if (/android/i.test(userAgent)) {
            console.log("android")

            window.location.href = appLinks.googlePlay;
        }
        else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
            console.log("iphone")

            window.location.href = appLinks.appStore;
        }
        else {
            console.log("default")
            window.location.href = appLinks.default;
        }
    }, []);

    return (

        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontFamily: 'Arial, sans-serif'
        }}>
            <p>Redirection en cours...</p>
        </div>
    );
};

export default AppRedirect;